(function($) {
	
	var timer = null;
	var hasErrors = false;
	var errorMessage = '';
	var statusURL = null;
	var restartMessage = '';
	
	var getStatus = function() {
        $.when($.ajax({
            url : statusURL,
            data: { requestType: 'status' },
            dataType: 'json',
            cache : false
        })).done(function(response) {
        	hasErrors = false;
        	var allMessages = '';
        	if (response.success) {
        		for (var i = 0; i < response.messages.length; i++) {
        			
        			var msg = response.messages[i];
        			
        			// Message has indicator:message
        			if (msg.indexOf(':') !== -1) {
	        			var parts = msg.split(':');
	        			allMessages += parts[1] + '<br/>';
	        			if (parts[0] !== 'end') {
	        				if (parts[0] === 'error') {
	        					errorMessage = parts[1];
	        					hasErrors = true;
	        				}
	        			} else {
	        				// Process done..
	        				$('.ok-button').attr('disabled', false);
	        				
	        				if (!hasErrors) {
		        				$('#statusText').html(configurationSaved);
	        					allMessages += restartMessage;
	        				}
	        				
	        				if (timer !== null) {
	        					clearInterval(timer);
	        					timer = null;
	        				}
	        			}
        			} else {
        				allMessages += msg;
        			}
        			
        			$('#statusList').html(allMessages);
        			$('#statusList').scrollTop($('#statusList')[0].scrollHeight);
        		}
        	}
        });
	};
	
	$.extend({
		showDatabaseConfigurationStatusDialog: function(options) {
			var myOptions = $.extend({}, { dialogId: '#dbConfigurationStatusDialog', okCallback: function() {} }, options);

            if (myOptions.statusURL) {
                statusURL = myOptions.statusURL;
			
                $(myOptions.dialogId).dialog({
                    width: 500,
                    modal: true,
                    draggable : false,
                    resizable : false,                   
                    classes: {'ui-dialog': 'cpwr-ui-dialog'},                    
                    buttons : {
                    	OK: {
                    		text: configOkButtonText,
                    		'class': 'ok-button',
                    		click: function() {
                    			myOptions.okCallback( !hasErrors, errorMessage );
                                $(this).dialog('close');
                    		}
                    	}
                    },
                    open: function() {
                    	$('.ok-button').attr('disabled', true);
                    }
                });
                
                restartMessage = options.restartMessage;
                getStatus();
                timer = setInterval(getStatus, 1000);
            }
		}
	});
	
}) (jQuery);